import { CaArea } from '../../core';

export function setFocusPhrase(value: CaArea, phrase: string | null): void {
    value.phrase = phrase;
}
